export enum ShopifyListingStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Archived = "ARCHIVED",
  Unlisted = "UNLISTED",
}
